import service from '@/store/services/settings/vessels-service';

const state = {
    list: {},
    vessel: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, vessel) => {
        state.vessel = vessel;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(vessel => {
                commit('SET_RESOURCE', vessel);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(vessel => {
                commit('SET_RESOURCE', vessel);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((vessel) => {
                commit('SET_RESOURCE', vessel);
                return vessel;
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((vessel) => {
                commit('SET_RESOURCE', vessel);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    vessel: state => state.vessel,
    dropdown: (state) => {
        return state.list.map(vessel => ({
            id: vessel.id,
            name: vessel.name,
        }));
    }
};

const vessels = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default vessels;
